
import React, { Fragment } from 'react'
import {AppRow,AppSelect} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row, Icon } from 'antd';

const apiData = [
    {attrName:'value',type:'string',defaultValue:'',remarks:'选项的value值'},
    {attrName:'onChange',type:'(value: string, text: string) => void',defaultValue:'',remarks:'选项该改变事件'},
    {attrName:'placeholder',type:'string',defaultValue:'',remarks:'placeholder'},
    {attrName:'readonly',type:'boolean',defaultValue:'false',remarks:'readonly'},
    {attrName:'options',type:'MetadataOption[]',defaultValue:'',remarks:'选项列表'}
]

const options = [{label:'选项1',value:'选项1'},{label:'选项2',value:'选项2'}]
export const AppSelectDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、选择框，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppSelect}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppSelectDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row style={{padding:20}}>
                    <AppRow>
                        <div style={{width:300}}>
                            <AppSelect options={options} />
                        </div>
                    </AppRow>
                </Row>
            
                
            </div>
            
            <h1>API</h1>
             <DemoApiTable data={apiData}/>
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppSelectDemo.tsx